import {Article} from "./Article";

export const AddArticleFormTemplate = Object.freeze({
        sections: [
            {
                size: 7 / 12,
                compact: true,
                inputs: [
                    Article.name,
                    Article.visible_timestamp
                ]
            }, {
                size: 1,
                compact: true,
                inputs: [
                    Article.text
                ]
            }
        ]
    }
);